import type { ReactNode } from "react";
import { COGNITO_ENABLED } from "../config";
import { CognitoAuthProvider } from "./cognito";
import { DevAuthProvider } from "./dev";

export { useAppAuth } from "./context";
export type { AppAuth } from "./context";

/** Selects the auth backend at build time: Cognito when a user pool is set, else dev-session. */
export function AuthProvider({ children }: { children: ReactNode }) {
  return COGNITO_ENABLED ? (
    <CognitoAuthProvider>{children}</CognitoAuthProvider>
  ) : (
    <DevAuthProvider>{children}</DevAuthProvider>
  );
}
